export default __webpack_public_path__ + "static/media/re4.47a266f6.png";